import { Banner } from '@/components/Banner/Banner';
import type { Bundle } from '@/components/Store.d';
import { languageStrings } from '@/l18n/de';
import { getPurKombiUrl } from '@/lib/banner';
import { config } from '@/lib/config';
import { isAnnualSubscription, setInnerHTML } from '@/lib/util';

type Props = {
	bundle: Bundle | null;
	printAccountNumber?: string;
};

const BannerExistingEntitlements = ({ bundle, printAccountNumber }: Props) => {
	if (!bundle) return null;

	const isAnnual = isAnnualSubscription(bundle);
	const ctaUrl = getPurKombiUrl(isAnnual, printAccountNumber);

	const text = getBannerText(bundle.bundleReference);

	/**
	 * Maps string content of banner to respective bundleRef
	 * @param {string} bundleRef
	 * @returns {string}
	 */
	function getBannerText(bundleRef?: string): { heading: string; explanation: string } {
		const env = import.meta.env.VITE_APP_ENVIRONMENT as 'development' | 'production';

		const refs = 'bundleRefs' in config[env] ? config[env].bundleRefs : null;

		switch (bundleRef) {
			case refs?.pur:
			case refs?.purYearly:
				return {
					heading: languageStrings.alreadyAcquiredEntitlements.pur.heading,
					explanation: languageStrings.alreadyAcquiredEntitlements.pur.explanation(String(ctaUrl))
				};
			case refs?.smartPlusPur:
			default: // Default to smart if no specific bundleRef is provided or bundleRefs not in config
				return {
					heading: languageStrings.alreadyAcquiredEntitlements.smart.heading,
					explanation: languageStrings.alreadyAcquiredEntitlements.smart.explanation(String(ctaUrl))
				};
		}
	}

	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{text.heading}</strong>
				<span dangerouslySetInnerHTML={setInnerHTML(text.explanation)}></span>
			</div>
		</Banner>
	);
};

export { BannerExistingEntitlements };
